import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/landingpages/dj-set1/DJ_Set_1_4.JPG")